// AreascontrolcambiosPage.tsx

import { MRT_ColumnDef } from "material-react-table";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  GeneralTable,
  SingleTableBoxScene,
  SwitchComponente,
} from "@/shared/components/ui";
import { useFetchGetAreascontrolcambios, useFetchDeleteAreascontrolcambios, useFetchPatchEstadoArea} from '@/shared/actions';
import { Tooltip, IconButton } from "@mui/material";
import BlockIcon from "@mui/icons-material/Block";
import {
  ROUTER_PATHS,
  TABLE_CONSTANTS_COLUMS,
  useTableFilter,
  // useTableServerSideFiltering,
} from "@/shared";
import { MRT_ColumnFiltersState } from 'material-react-table';
import { useUiConfirmModalStore } from "@/store/ui";
import { Areascontrolcambios } from "../../types";
//permisos
import { useAuthStore } from "@/store/auth/auth.store"; 
import { useUserModulesStore } from "@/store/auth";       
import { SystemModulesEnum } from "@/auth/interfaces";
import { Outlet } from "react-router-dom";
import { toFilterParams } from "@/erp/controlcambios/servidores";

export default function AreascontrolcambiosPage() {
  //permisos
  const user = useAuthStore((s) => s.user) as any; 
  const userModules = useUserModulesStore((s) => s.modules);  
  const isSuper = !!user?.is_superuser || !!user?.is_staff; 
  const tineAccesoAreacontrolAreas = userModules.includes(SystemModulesEnum.CONTROL_CAMBIOS_AREAS) 





  ///
  const returnObservacionUrl = ROUTER_PATHS.control_cambios.areaNav;
  const navigate = useNavigate();
  const setConfirmDialog = useUiConfirmModalStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    (s) => s.setConfirmDialogIsOpen
  );
  const {

    pagination,

    setPagination,

  } = useTableFilter();
  const { pageIndex, pageSize } = pagination;
  // const { columnFilters, setColumnFilters } = useTableServerSideFiltering();
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>([]);
  //feacth
   const {
    data:response,
    isLoading,
    isRefetching,
  } = useFetchGetAreascontrolcambios({
    page: pageIndex,
    size: pageSize,
    ...toFilterParams(columnFilters),
  });
  //mutaciones
  const deleteAreaControlCambios = useFetchDeleteAreascontrolcambios();
  const patchEstadoArea = useFetchPatchEstadoArea();
  const onEdit = (original:Areascontrolcambios) => {
      setConfirmDialog({
      isOpen: true,
      title: "Editar observacion",
      subtitle: "¿Esta seguro que desea editar este registro?",
      onConfirm:() =>{
        setConfirmDialogIsOpen(false);
        navigate(`${returnObservacionUrl}/editar/${original.areaId}`)
      }
    });
  }
    const onDelete = (origin:Areascontrolcambios) =>{
    setConfirmDialog({
      isOpen: true,
      title: "Eliminar observación",
      subtitle: `¿Está seguro que desea eliminar la observación "${origin.nombre}"? Esta acción no se puede deshacer.`,
      onConfirm: () => {
        setConfirmDialogIsOpen(false);
        deleteAreaControlCambios.mutate(origin.areaId!);
      },
    });
  };
  const columns = useMemo<MRT_ColumnDef<Areascontrolcambios>[]>(
    () => [
      {
        accessorKey: "areaid",
        header: "Identificación del area",
        size: 180,
         Cell: ({ row }) => row.original?.codigo || 'N/A',

      },
      {
        accessorKey: "nombre",
        header: "Nombre del area",
        size: 180,
         Cell: ({ row }) => row.original?.nombre || 'N/A',

      },
      {
        accessorKey: "activo",
        header: "¿Está activo?",
        size: 140,
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <SwitchComponente
            estadoSwitch={!!row.original.activo}
            titulo={row.original.activo ? "Activo" : "Inactivo"}
            setEstadoSwitch={() => {
              setConfirmDialog({
                isOpen: true,
                title: "Cambiar estado",
                subtitle: "¿Seguro que desea cambiar el estado del área?",
                onConfirm: () => {
                  setConfirmDialogIsOpen(false);
                  patchEstadoArea.mutate({ id: row.original.areaId!, activo: !row.original.activo });
                },
              });
            }}
          />
        ),
      },
      {
        accessorKey: "descripcion",
        header: "Description del area",
        size: 180,
         Cell: ({ row }) => row.original?.descripcion || 'N/A',
      }
    ], []
  );

  if(!isSuper || !tineAccesoAreacontrolAreas){
      return (
        <SingleTableBoxScene
        title={"Areas de control de cambios"}
        urlRedirect={`${returnObservacionUrl}/crear`}
          py={2}
          visibleReport={true}
        >
          <GeneralTable<Areascontrolcambios>
            columns = {columns}
            data= { response?.data|| []}
    
            isLoading ={isLoading}
            isRefetching= {isRefetching}
            enableGlobalFilter = {false}
            enableManualFiltering = {true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            pagination={pagination}
            onPaging={setPagination}
            rowCount={response?.totalElements ?? 0}
            actionsColumnSize={TABLE_CONSTANTS_COLUMS.ACTIONCOLUMN_WIDTH}
            positionActionsColumn="first"
    
            canEdit={true}
            onEdit={onEdit}
            canDelete={false}
            showCustomActionBtnSpace={true}
            customActionBtnSpace={(value) => {
              const area = value as Areascontrolcambios;
              return (
                <Tooltip title="Desactivar">
                  <span>
                    <IconButton color="warning" size="small" onClick={() => onDelete(area)}>
                      <BlockIcon fontSize="small" />
                    </IconButton>
                  </span>
                </Tooltip>
              );
            }}
    
            />
          {/* <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 3 }} >
            <Tabs
              value={valueTab}
              onChange={(_event: React.SyntheticEvent, newValue: number) => {
                setValueTab(newValue);
              }}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              aria-label="scrollable force tabs areascontrolcambios"
            >
              <Tab label={'TAB 1'} {...a11yProps(0)} />
            </Tabs>
          </Box>
          <CustomTabPanel value={valueTab} index={0}>
            <TableAreascontrolcambios />
          </CustomTabPanel> */}
        </SingleTableBoxScene >
      )

  }
  return <Outlet />;
}